import { Flex, Text, Box } from '@chakra-ui/react';
import { faTriangleExclamation } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal } from '@morressier/alembic';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onRemove: () => void;
  isLoading: boolean;
}

const RemoveMember = ({ onRemove, isOpen, onClose, isLoading }: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    width={{ base: 'calc(100vw - 16px)', md: '450px' } as any}
    closeButtonProps={{
      isDisabled: true
    }}
  >
    <Flex flexDirection={'column'} gap={4} padding={{ base: 4, md: 8 }}>
      <Box fontSize="32px">
        <FontAwesomeIcon icon={faTriangleExclamation} />
      </Box>
      <Flex flexDirection={'column'} gap={2}>
        <Text textStyle="headingGroup">Remove Member from Workspace?</Text>
        <Text textStyle="textBody">
          You are about to remove this member from this Workspace: this action
          is irreversible. Do you wish to continue?
        </Text>
      </Flex>
      <Flex gap={2} width="100%" justifyContent="flex-end">
        <Button onClick={onClose} variant="secondary" isDisabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="caution"
          onClick={onRemove}
          isDisabled={isLoading}
          isLoading={isLoading}
        >
          Remove
        </Button>
      </Flex>
    </Flex>
  </Modal>
);

export default RemoveMember;
